import React, { useState } from 'react';
import "./Footer.css";
import ChatComponent from '../Chat/ChatComponent';
import SpeechToTextModal from '../Pages/SpeechToTextModal';
import AskAnalystModal from '../Pages/AskAnalystModal';
import { Link, useLocation } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { JS_CSS_IMG_VERSION } from '../../../config/apiConfig';


export default function Footer() {

  const [showSpeechToTextModal, setShowSpeechToTextModal] = useState(false);
  const [showAnalystModal, setShowAnalystModal] = useState(false);

  const handleShowSpeechToTextModal = (show_flg) => {
    setShowSpeechToTextModal(show_flg)
  }

  const closeSpeechToTextModal = () => {
    handleShowSpeechToTextModal(false);
  };
  
  const handleShowAskAnalystModal = (show_flg) => {
    setShowAnalystModal(show_flg)
  }

  const closeAskAnalystModal = () => {
    handleShowAskAnalystModal(false);
  };

  const location = useLocation();
  const isSubcomponentOfAccountDetails = window.location.href.includes('account_details');
  
  const renderTooltip = (title, use_case_text) => (
    <Tooltip className="custom-use-case-tooltip-footer" placement="left">
      <b>{title}</b> {use_case_text}
    </Tooltip>
  );
  return (
    // <div className='footer_wrapper'>
    //   <footer className="footer-distributed">

    //   <div className="footer-left">

    //     <a href="#" className="footer_logo"> 
    //           <img src="/img/Footer_logo.png" alt="logo" width="140" className="" />
    //     </a>   

    //   </div>

    //     <div className="footer-center">

    //     <p className="footer-company-about">
    //           <span>Sales related query</span>
    //       </p>
    //       <div className='mb-2'>
    //         <i className="fa fa-phone"></i>
    //         <p>+1 (206) 401-8844</p>
    //       </div>

    //       <div>
    //         <i className="fa fa-envelope"></i>
    //         <p><a href="mailto:salesplay@marketsandmarkets.com">salesplay@marketsandmarkets.com</a></p>
    //       </div>

    //     </div>      

    //   </footer>
    //   <div className="copyright">
    //     <p className='copyright_content'><span className='copyright_icon'>&#169;</span>	 2014-2024 MarketsandMarkets research private Ltd. all rights reserved</p>
    //     </div>
    // </div>
   
    <div className='footer_wrapper'>
      
        {/* <!--sppech to text btn--> */}
        <div className="sticky-button-block d-none">
            
            <button className='sticky_btn' title="speech to text" onClick={()=> handleShowSpeechToTextModal(true)}>
                <img src="/img/text-to-speech.png" className='icon'/>
            </button>
        </div>
        {/* <!--sppech to text btn--> */}

        {/* <!--request analysis btn--> */}
        {isSubcomponentOfAccountDetails && (<div className="ask_analyst_block">
            <button className='sticky_btn d-none' title="" onClick={()=> handleShowAskAnalystModal(true)}>
                <img src="/img/ask_analyst.png" className='icon'/>
                <p className='ana_para'>Analyst</p>
            </button>

            {/*
                    <OverlayTrigger  placement="left" overlay={renderTooltip("", "Ask Analyst")}>

             <button className='sticky_btn' title="Ask Analyst" onClick={()=> handleShowAskAnalystModal(true)}>
                <img src="/img/ask_analyst.png" className='icon'/>
            </button> 
                    </OverlayTrigger>            

            */}
        </div>)}
        {/* <!--request analysis btn--> */}


      {showSpeechToTextModal && <SpeechToTextModal show={showSpeechToTextModal} handleClose={closeSpeechToTextModal} /> }
      {showAnalystModal && <AskAnalystModal show={handleShowAskAnalystModal} handleClose={closeAskAnalystModal} /> }
      
      <footer>	
        <div className="col-12">
            <section className="section-1">
                <ul	className="list-inline footer-list container">
                    <li>
                      {/* <img src={`/img/footer_icons/Footer_logo.png?version=${JS_CSS_IMG_VERSION}`} width="130" alt="logo"/> */}
                      <img src={`/img/mnm_logo.png?version=${JS_CSS_IMG_VERSION}`} width="130" alt="logo"/>
                      
                    </li>
                    <li>
                        <div className="section-1-item">
                            <div>
                                <span className="phone-icon1 pr-1">
                              <img src="/img/footer_icons/call.png" height="30" width="30" alt="phone"/>

                            </span>
                            </div>
                            <div className="">
                                <h4> +1 (206) 401-8844 </h4>
                                <h5> (US Office HQ) </h5>
                            </div>
                        </div>
                    </li>
                  
                    <li>
                        <div className="section-1-item">
                            <div>
                            <span className="phone-icon1 pr-1">
                              <img src="/img/footer_icons/call.png" height="30" width="30" alt="phone"/>

                            </span>
                            </div>
                            <div className="">
                                <h4> +44 20 3869 5400  </h4>
                                <h5> (UK Office) </h5>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="section-1-item">
                            <div>
                            <span className="phone-icon1 pr-1">
                              <img src="/img/footer_icons/Mail.png" height="30" width="30" alt="phone"/>

                            </span>
                            </div>
                            <div className="">
                            <a href="mailto:salesplay@marketsandmarkets.com">salesplay@marketsandmarkets.com</a>
                            </div>
                        </div>
                    </li>
                </ul>
            </section>
        </div>

    <div className="col-md-12 col-12">            
        <section className="section-2">	
            <div className="container">
                <div className="row">
                    <div className="col-md-3 col-12 social-icons">
                        <h4>Connect With Us</h4>
                        <ul className="list-inline d-flex">
                            <li className="pr-2 " ><a href="http://www.facebook.com/pages/Market-Research-Report/171919766173321" title="Follow us on Facebook" rel="nofollow noopener noreferrer" target="_blank"> <span className="facebook-icon s-icon"> </span> </a></li>
                            <li className="pr-2 pl-1"><a href="http://twitter.com/marketsmarkets" rel="nofollow noopener noreferrer" target="_blank"> <span className="twitter-icon s-icon"> </span> </a></li>
                            <li className="pr-2 pl-1"><a href="http://www.linkedin.com/company/marketsandmarkets" rel="nofollow noopener noreferrer" title="Check" target="_blank"> <span className="linkedin-icon s-icon"> </span> </a></li>

                        </ul>					
                    </div>
                    <div className="col-md-6 col-12 text-center footer-menu">
                        <ul className="list-inline  custom-list d-flex justify-content-center">
                            <li className="pr-2" > <Link to="#" rel="nofollow noopener noreferrer" >About</Link> </li>
                            <li className="pr-2"> <Link to="/pages/privacy_policy" rel="nofollow noopener noreferrer">Privacy Policy</Link> </li>
                            <li className="pr-2" > <Link to="/pages/accessibility" rel="nofollow noopener noreferrer" >Accessibility</Link> </li>
                            <li className="pr-2" > <Link to="/pages/disclaimer" rel="nofollow noopener noreferrer">Disclaimer</Link> </li>
                            <li className="pr-2"> <Link to="/pages/terms_of_use" rel="nofollow noopener noreferrer">Terms of Use</Link> </li>
                            <li className="pr-2"> <Link to="#" rel="nofollow noopener noreferrer">Help</Link> </li>
                        </ul>
                        <p>© 2014-2025 MarketsandMarkets Research Private Ltd. All Rights Reserved.</p>
                                                      
                    </div>
                    <div className="col-md-3 col-12 cards-payment">
                        <h4>About Trust Online</h4>
                        <ul className="list-inline d-flex">
                            <li className="pr-2" > <span className="visa-icon c-icon"> </span> </li>
                            <li className="pr-2"> <span className="mastercard-icon c-icon"> </span> </li>
                            <li className="pr-2"> <span className="american-icon c-icon"> </span> </li>
                            <li className="pr-2"> <span className="paypal-icon c-icon"> </span> </li>
                        </ul>
                    </div>
                </div>	
            </div>			
        </section>           
    </div>		
        
	</footer>
    </div>
  )
}
